export const SERVICE_TYPES = {
  ONLINE_ASSISTANCE: 'ONA',
  REVIEW_TUNING: 'RET',
  HOME_REPAIR: 'HOR',
  NONE: false,
};